import { ActionBase } from '../../../core/store/action/ActionBase';

export const UNGROUP_RULE_CONDITIONS = '[DynamicDataSet] Ungroup Rule Conditions';

export class UngroupRuleConditionsAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = UNGROUP_RULE_CONDITIONS;

  constructor(public payload: { dynamicDataSetKey: string; dynamicRuleKey: string; groupName: string }) {}
}



// WEBPACK FOOTER //
// ./src/app/dynamicDataSets/store/actions/UngroupRuleConditionsAction.ts